import { CEIdentityBase } from './ce-identity-base'


export class CEIdentity extends CEIdentityBase {

}